import Grid from '@material-ui/core/Grid'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React, { FC } from 'react'

interface StepFourProps {
  successMessage: string
}

const useStyles = makeStyles((theme) =>
  createStyles({
    calloutText: {
      margin: 'auto',
      textAlign: 'center',
      fontSize: '3.8rem',
      fontWeight: 300,
      lineHeight: 1.15,
      letterSpacing: '-1.5px',
      color: '#FFFFFF',

      '& a': {
        color: 'inherit',
      },

      [theme.breakpoints.down('sm')]: {
        fontSize: '3.6rem',
        margin: '0 -28px 48px -12px',
      },
    },
  }),
)

const StepFour: FC<StepFourProps> = ({ successMessage }) => {
  const classes = useStyles()

  return (
    <Grid container direction="column" style={{ margin: 'auto' }}>
      <Typography className={classes.calloutText} component="h3">
        {successMessage}
      </Typography>
    </Grid>
  )
}

export default StepFour
